<<template>
 <div ref="listPanel" id="listPanel" class="list-panel" >
    <div class="data-head">
      <div class="data-head-warp" :style='"width:"+(tableWidth + 200)+"px"'>
        <table :style='"width:"+tableWidth+"px"' class="table-head" >
          <colgroup>
            <col width="40px" />
            <col v-for='cl in config.listDefine' v-if='!cl.right || rights(cl.right)' :width='(cl.width? cl.width : 100) + "px"' />
          </colgroup>
            <thead>
              <head-ths :config='config' :rs="rs">
                <th style="width:40px; cursor: pointer;">
                  <div @click.stop="selAll" :title='rs["selAll"]' style="width:100%; height: 25px; cursor: crosshair;"></div>
                </th>
              </head-ths>
            </thead>
        </table>
      </div>
    </div>
    <div @scroll="dataBodyScroll" class='data-body'>
      <div class='data-body-warp'>
        <table :class='[config.bodyClass? "table-body table-hover " + config.bodyClass : "table-body table-hover"]'
        :style='"width:"+tableWidth+"px"' >
          <colgroup>
            <col width="40px" />
            <col v-for='cl in config.listDefine' v-if='!cl.right || rights(cl.right)' :width='(cl.width? cl.width : 100) + "px"' />
          </colgroup>
          <tbody>
            <tr v-for='(item,index) in config.list' @click.stop="rowSel($event, index, item)" 
            @dblclick.stop='rowDbclick(index, item)' :class="isSel(index)? 'selected':''" :style='rowStyler(index, item)' >
              <td>{{index + 1}}</td>
              <td v-for='cl in config.listDefine' v-if='!cl.right || rights(cl.right)'>
                  <div v-if='!cl.type || cl.type=="sortClumn"' class="td-div">{{initData(cl, item)}}</div><span v-else-if='cl.type=="textClumn"'>{{initData(cl, item)}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</div>

</template>

<script>
import hths from "./headThs";
export default {
  props: ["config", "isAutoLoad", "rs", "selIdx"],
  created: function() {
    if (this.config.list.length == 0 && this.isAutoLoad)
      this.$loadData(this.config, 1);

    if (this.config.formatter)
      this.$extend(this.formatter, this.config.formatter);
  },
  /*updated(){
    console.log("listPanel.updated" + this.isNeedInitHeight)
    if (!this.isNeedInitHeight){
      //setTimeout(() => {
      //  window.fuiInitListPanelHeight()
      //}
      //,1200)
    } 
    this.isNeedInitHeight = 1
    console.log("listPanel.updated")
  },*/
  mounted: function() {
     window.fuiNeedInitHeight = 1
  //  this.isNeedInitHeight = 1
    //console.log("mounted")
    //setTimeout(() => {
    //console.log("initListPanelHeight")
      //this.$initListPanelHeight();
    //  window.fuiInitListPanelHeight(null, this.$refs.listPanel.$el)
    //}, 500);
  
  },
  /*date(){
    return {
      isNeedInitHeight: 0
    }
  },*/
  computed: {
    tableWidth: function() {
      let width = 0
      let df = this.config.tdDefaultWidth || 100
      const list = this.config.listDefine;
      for (let i = 0; i < list.length; i++) {
        width += list[i].width ? list[i].width : df
      }
      const bw = window.fuiContentWidth - 25
      return width >= bw ? width : bw
    }
  },
  methods: {
    dataBodyScroll () {
      const el = event.target || event.srcElement
      let xl = el.previousSibling
      while (xl.nodeType != 1) xl = xl.previousSibling
      xl.scrollLeft = el.scrollLeft
    },
    rowStyler(index, item){
      if (!this.config.rowStyler) return ""
      return this.config.rowStyler(index, item)
    },
    isSel(idx) {
      if (this.selIdx == undefined ) return false
      return idx == this.selIdx || (typeof this.selIdx == "object" && this.selIdx.indexOf(idx) >= 0)
    },
    rowSel(ev, idx, row) {
      let sidx = undefined 
      let isSel = false
      let i = null
      if (this.selIdx == undefined) isSel = false
      else if (typeof this.selIdx == "number") isSel = idx == this.selIdx
      else if (typeof this.selIdx == "object") {
        i = this.selIdx.indexOf(idx)
        isSel = i >= 0
      }

      if (isSel){
        if (ev.ctrlKey && i!=null){
          if (this.selIdx.length == 1) sidx = undefined
          else{
            this.selIdx.splice(i,1)
            sidx = this.selIdx
          }
        } 
        else if(i != null) sidx = idx
      }
      else if (ev.ctrlKey) {
        if (typeof this.selIdx == "object") {
          sidx = [idx].concat(this.selIdx)
        }
        else if (this.selIdx != undefined){
          sidx = [this.selIdx,idx]
        }
        else sidx = idx
      }
      else sidx = idx
      this.$emit("updateIdx", sidx);
    },
    selAll() {
      this.selIdx = [];
      for (let i = 0; i < this.config.list.length; i++)
        this.selIdx.push(i);
    },
    isShow(cl, item) {
      return (
        cl.isShow == true ||
        !cl.isShow ||
        this.formatter[cl.isShow](cl, item, this.rs)
      );
    },
    initData(cl, item) {
      if (typeof cl == "string") return item[cl];
      const v = item[cl.key];
      if (cl.formatter) {
        let tmp = this.formatter[cl.formatter](v, cl, item, this.rs);
        return this.rs[tmp] || tmp;
      }
      else if (cl.vformatter && this.formatter[cl.vformatter]) {
        return this.formatter[cl.vformatter](v, cl, item, this.rs)
      }
      else return v;
    },
    selCell(e, item, key) {
      const el = e.srcElement;
      if (el.tagName == "INPUT") return;
      const cb = el.querySelector("input");
      if (!cb.checked) {
        cb.checked = true;
        item[key] = true;
      } else {
        cb.checked = false;
        item[key] = false;
      }
    },
    rowDbclick(idx, row) {
      this.$emit("rowDbclick", idx, row);
    }
  },
  /*  updated(){
      console.log("updated")
    },*/
  components: {
    "head-ths": hths
  }
};
</script>
